import { capture } from './capture';

/**
 * Identity-claim funnel events — see docs/product-analytics-contract.md
 * §"Identity claim events".
 *
 * No other properties are ever sent — never the email, the code or the
 * password.
 */
export type IdentityClaimEvent =
  | 'identity_claim_card_viewed'
  | 'identity_claim_started'
  | 'identity_claim_postponed'
  | 'identity_claim_email_submitted'
  | 'identity_claim_no_email_clicked'
  | 'identity_claim_email_rejected'
  | 'identity_claim_code_confirmed'
  | 'identity_claim_password_set'
  | 'identity_claim_completed';

export type IdentityClaimEntryPoint = 'card' | 'profile';

export const captureIdentityClaim = (
  event: IdentityClaimEvent,
  props: { entry?: IdentityClaimEntryPoint } = {}
): void => capture(event, props);
